<template>
  <div>
    <section class="Head">
      <div class="top-BG"></div>
      <div class="form-group row">
        <div class="col-md-12 text-white">
          <div class="title-line"></div>
          <h4><i class="fas fa-file-invoice-dollar"></i> Cobrança</h4>
        </div>
      </div>
      <section v-show="!allAreChecked" class="cards__container">
        <div class="head-card">
          <div class="head-card__left">
            <p class="head-card__left__title">Cards totais</p>
            <p v-if="!loading" class="head-card__left__info">{{ dashBoard.totalCards }}</p>
            <b-skeleton v-else width="60%"></b-skeleton>
          </div>
          <div class="head-card__right">
            <i class="fas fa-id-card-alt fa-gradient"></i>
          </div>
        </div>
        <div class="head-card">
          <div class="head-card__left">
            <p class="head-card__left__title">Sem responsável</p>
            <p v-if="!loading" class="head-card__left__info">{{ dashBoard.cardsSemResponsaveis }}</p>
            <b-skeleton v-else width="60%"></b-skeleton>
          </div>
          <div class="head-card__right"><i class="fas fa-user-tie"></i></div>
        </div>
        <div class="head-card">
          <div class="head-card__left">
            <p class="head-card__left__title">Sem interação</p>
            <p v-if="!loading" class="head-card__left__info percent">{{ dashBoard.cardsComInteracao ?
              new Intl.NumberFormat('pt-BR', {maximumFractionDigits: 2}).format(((dashBoard.totalCards - dashBoard.cardsComInteracao) / dashBoard.totalCards) * 100) : 100 }}</p>
            <b-skeleton v-else width="60%"></b-skeleton>
          </div>
          <div class="head-card__right"><i class="fas fa-exclamation"></i></div>
        </div>
        <div class="head-card">
          <div class="head-card__left">
            <p class="head-card__left__title">Valor total</p>
            <p v-if="!loading" class="head-card__left__info">{{ dashBoard.valorTotalProdutosCards ?
              dashBoard.valorTotalProdutosCards.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) : '-' }}</p>
            <b-skeleton v-else width="60%"></b-skeleton>
          </div>
          <div class="head-card__right"><i class="fas fa-funnel-dollar"></i></div>
        </div>
      </section>
    </section>
    <section class="body">
      <div v-if="allAreChecked" class="allChecked__info__container">
        <template>
          <span v-if="!selectedAllFromFilter">Todos os <strong>{{ firstPageTotalElements }}</strong> cards nesta página
            estão selecionados. <b-link v-if="totalElements > firstPageTotalElements" @click="selectAllFromFilter">Selecionar todos os <strong>{{ totalElements
            }}</strong> card filtrados</b-link></span>
          <span v-else>Todos os <strong>{{ totalElements }}</strong> cards filtrados estão selecionados. <b-link
              @click="allUnchecked">Limpar seleção</b-link></span>
        </template>
      </div>
      <Tables ref="tableGrid" :columns="[
        { name: 'checkbox', checkbox: true },
        'Nome',
        'Produto',
        'Agendamento',
        'Etapa',
        'Valor Total',
        'Risco Sicoob',
        'Risco Bacen',
        'Interação',
        'Data Interação'
      ]" :showFirstCustom="isTablet ? false : { text: 'Atribuir', icon: 'fas fa-user' }"
        :showSecondCustom="true ? null : { text: 'Remover atribuição', icon: 'fas fa-user-slash' }"
        :showSearch="true" :showReload="true" :showNew="isTablet ? false : true" :showTipFooter="false"
        v-on:FirstCustom="openAsignModal" v-on:SecondCustom="openRemoveModal" v-on:Search="onShowSearch"
        v-on:Load="onLoad" v-on:Reload="onLoad" v-on:New="onNew" v-on:allChecked="allChecked"
        v-on:allUnchecked="allUnchecked">
        <tr v-for="(obj, index) in objList" v-bind:key="index" @click="onCardCheck(obj.card.id)">
          <td class="text-center">
            <!-- CLICK NA ROW, MARCA O CHECKBOX && CLICK NO TEXTO, ABRE A MODAL -->
            <input v-if="allAreChecked" type="checkbox" checked disabled />
            <input v-else type="checkbox" :checked="selectedCards.some(cardId => cardId === obj.card.id)"
              v-bind:key="index" @click.stop="onCardCheck(obj.card.id)" />
          </td>
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
            :value="obj.name ? obj.name.toUpperCase() : ''" />
          <td class="text-center badges__container">

            <span v-for="(product, index) in obj.products" v-bind:key="index" @click="openCard(obj.card.id)"
              :class="[
                'badge',
                'text-toupper',
                `bg-color-${product.type
                  .replaceAll(' ', '-')
                  .toLowerCase()}`,
              ]" v-b-popover.hover="{
              title: product.type,
              content: `Operação: ${product.operationNumber} <br> Valor: R$ ${valueToMoney(product.amount)} <br> Risco: ${product.risk}`,
              variant: 'light',
              html: true
            }">
              {{ generateBadge(product.type) }}</span>
            <span v-if="obj.products.length === 0">-</span>
          </td>
          <TableColumn :class="setBackgroundAgendamento(obj)" v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
          :value="obj.cardDetails.agendamento ? formatDate(obj.cardDetails.agendamento, true) : '-'" />
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
          :value="obj.board ? obj.board.columnName.toUpperCase() : '-'" />
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1" :value="obj.totalAmount ? obj.totalAmount.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' }) : '-'
            " />
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
            :value="obj.sicoobRisk ? obj.sicoobRisk.toUpperCase() : '-'" />
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
            :value="obj.bacenRisk ? obj.bacenRisk.toUpperCase() : '-'" />
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
            :value="obj.interacao ? obj.interacao : '-'" />
          <TableColumn v-on:Edit="openCard(obj.card.id)" :IsText="true" :status="obj.inative ? 0 : 1"
            :value="obj.dataInteracao ? moment.utc(obj.dataInteracao).format('DD/MM/YYYY HH:mm') : '-'" />
        </tr>
      </Tables>
    </section>
    <vue-fab v-if="isTablet" size="big" id="fabMobile" icon="add" mainBtnColor="#04a791" class :scrollAutoHide="false">
      <fab-item :idx="2" title="Atribuir" color="#00C851" icon="group_add" @clickItem="openAsignModal"></fab-item>
      <fab-item :idx="1" title="Remover Atribuição" color="#FF4444" icon="group_off"
        @clickItem="openRemoveModal"></fab-item>
      <fab-item :idx="0" title="Adicionar Novo" color="#4285f4" icon="add" @clickItem="onNew"></fab-item>
    </vue-fab>
    <ModalCard ref="ModalCard" v-if="selectedCard" :boardColumns="[]" @hideModal="closeCard" :key="selectedCard"
      :cardId="selectedCard" @reloadBoardColumns="reloadGrid" />
    <NewLeadModal ref="NewLeadModal" @Back="closeNewLeadModal" />
    <AddAsignModal v-if="modalType" :selectedCards="selectedAllFromFilter ? null :selectedCards" :key="modalType" :modalType="modalType" :filters="selectedAllFromFilter ? filters : null"
      @closeModal="closeAsignModal" ref="AddAsignModal" />
    <SidebarSearch @search="onSearch" />
  </div>
</template>
<script>
import ActionsForm from '@/shared/mixins/actionsForm'
import createColor from '@/shared/utils/stringToColor.js'
import Tools from '@/components/tools/Tools.js'
import NewLeadModal from './modal/new/newlead.vue'
import AddAsignModal from './modal/asign/addAsign.vue'
import ModalCard from '@/views/private/crm/components/modalCard/modalCard.vue'
// import CardSearchScreen from './search/search.vue'
import SidebarSearch from '@/views/private/cobranca/search/SidebarCobranca.vue'
import { toast } from '@/shared/utils/UIHelper'

import CobrancaCardRepository from '@/shared/http/repositories/crm/cardCobranca.js'

const modalTypes = {
  0: 'add',
  1: 'remove'
}

export default {
  name: 'Cobranca',
  mixins: [ActionsForm],
  data () {
    return {
      allAreChecked: false,
      allCardsId: [],
      selectedAllFromFilter: false,
      firstPageTotalElements: 8,
      totalElements: 0,
      modalType: null,
      loading: true,
      loadingAllCards: false,
      selectedCards: [],
      checkbox: false,
      dashBoard: {},
      selectedCard: null,
      filters: null,
      isTablet: screen.width <= 768
    }
  },
  components: {
    NewLeadModal,
    AddAsignModal,
    ModalCard,
    SidebarSearch
  },
  beforeDestroy () {
    this.$eventHub.off('Filter')
    Tools.MinimizedASidebar()
  },
  mounted () {
    this.$eventHub.on('Filter', ({ filters }) => {
      this.filters = filters
      this.$nextTick(() => {
        this.onSearch(filters)
      })
    })
  },
  methods: {
    onShowSearch () {
      this.$root.$emit('bv::toggle::collapse', 'sidebar-1')
    },
    onSearch (filters) {
      if (filters) {
        this.filters = ''

        if (filters.boardId === 'boardArquivado=true' || filters.boardId === 'boardArquivado=false') {
          this.filters += filters.boardId
          delete filters.boardId // Remove o boardId dos filtros para que não seja processado novamente
        }

        this.filters = Object.entries(filters)
          .filter(([_, value]) => !!value)
          .map(([key, value]) => `&${key}=${value}`)
          .join('')

        if (filters.interacao === false) {
          this.filters += '&interacao=false'
          delete filters.interacao // Remove o interacao dos filtros para que não seja processado novamente
        }
      }
      this.backToInitialPage()
    },
    reloadGrid () {
      this.onLoad()
    },
    onLoad () {
      this.onLoadFilters()
      this.OnLoadDashboard()
      this.selectedCards = []
    },
    onLoadFilters () {
      const situacao = 'ATIVO'
      CobrancaCardRepository.Search(situacao, this.filters, this.$refs.tableGrid.pagingLimit, this.$refs.tableGrid.pagingIndex)
        .then(response => {
          this.onResultGrid(response)
          this.totalElements = response.data.totalElements
          this.loading = false
        })
        .catch(this.onException)
    },
    onReloadBoard () {
      this.onLoadFilters()
      this.OnLoadDashboard()
    },
    backToInitialPage () {
      this.$refs.tableGrid.ReloadCountPage()
    },
    OnLoadDashboard () {
      let situacao = 'ATIVO'
      CobrancaCardRepository.RefreshDashboard(situacao, this.filters)
        .then((res) => {
          this.dashBoard = res.data
        })
    },
    onNew () {
      this.$refs.NewLeadModal.showModal()
    },
    openAsignModal () {
      if (this.selectedCards.length > 0 || this.selectedAllFromFilter) {
        this.modalType = modalTypes[0]
        this.$nextTick(() => {
          this.$refs.AddAsignModal.showModal()
        })
      } else {
        toast.warning('Nenhum card foi selecionado', 'ATENÇÃO')
      }
    },
    openRemoveModal () {
      if (this.selectedCards.length > 0) {
        this.modalType = modalTypes[1]
        this.$nextTick(() => {
          this.$refs.AddAsignModal.showModal()
        })
      } else {
        toast.warning('Nenhum card foi selecionado', 'ATENÇÃO')
      }
    },
    closeAsignModal () {
      this.onLoadFilters()
      this.allUnchecked()
      this.selectedCards = []
      this.modalType = null
    },
    closeNewLeadModal () {
      this.onLoadFilters()
    },
    generateBadge (product) {
      createColor(product)
      return Tools.abreviateWord(product)
    },
    openCard (cardId) {
      this.selectedCard = cardId
    },
    closeCard () {
      this.selectedCard = null
    },
    openBoard (boardId) {
      this.$router.push({
        name: 'Quadro',
        params: { boardId: boardId, backUrl: 'Cobrança' }
      })
    },
    onCardCheck (id) {
      let index = this.selectedCards.indexOf(id)
      index !== -1
        ? this.selectedCards.splice(index, 1)
        : this.selectedCards.push(id)
    },
    uncheckCheckboxes () {
      this.checkbox = false
    },
    allChecked () {
      this.objList.forEach(obj => {
        if (!this.selectedCards.includes(obj.card.id)) this.selectedCards.push(obj.card.id)
      })
      this.firstPageTotalElements = this.$refs.tableGrid.pagingLimit > this.objList.length ? this.objList.length : this.$refs.tableGrid.pagingLimit
      this.allAreChecked = true
    },
    allUnchecked () {
      this.selectedCards = []
      this.allAreChecked = false
      this.selectedAllFromFilter = false
    },
    selectAllFromFilter () {
      this.selectedCards = []
      this.selectedAllFromFilter = true
    },
    setBackgroundAgendamento (card) {
      let agendamentoClass = ''
      let agendamento = card.cardDetails.agendamento

      if (!agendamento) {
        return agendamentoClass
      } else {
        if (this.isAgendamentoPassed(agendamento)) {
          agendamentoClass = 'agendamento__passed'
        } else if (this.isAgendamentoToday(agendamento)) {
          agendamentoClass = 'agendamento__today'
        }
      }
      return agendamentoClass
    },
    isAgendamentoPassed (agendamento) {
      const agendamentoDate = this.moment.utc(agendamento).format('DD/MM/YYYY HH:mm')
      const dataAtual = new Date()

      const ag = this.moment(agendamentoDate, 'DD/MM/YYYY hh:mm')
      const hoje = this.moment(dataAtual, 'DD/MM/YYYY hh:mm')

      return hoje.diff(ag, 'minutes') > 0
    },
    isAgendamentoToday (agendamento) {
      const agendamentoDate = new Date(agendamento)
      const currentDate = new Date()

      const agendamentoDateNoTime = `${agendamentoDate.getDate()}/${agendamentoDate.getMonth() + 1}/${agendamentoDate.getFullYear()}`
      const currentDateNoTime = `${currentDate.getDate()}/${currentDate.getMonth() + 1}/${currentDate.getFullYear()}`

      if (agendamentoDateNoTime === currentDateNoTime) {
        return true
      } else {
        return false
      }
    },
    valueToMoney (value) {
      let numberValue = +value
      let money = numberValue.toLocaleString('pt-Br', { style: 'currency', currency: 'BRL' })
      return money
    },
    formatDate (d, hasTime) {
      const date = new Date(d)
      date.setHours(date.getHours() + 3)

      const day = date.getDate().toString().padStart(2, '0')
      const month = (date.getMonth() + 1).toString().padStart(2, '0')
      const year = date.getFullYear()
      const hours = date.getHours().toString().padStart(2, '0')
      const minutes = date.getMinutes().toString().padStart(2, '0')

      return `${day}/${month}/${year}` + (hasTime ? ` às ${hours}:${minutes}` : '')
    }
  }
}
</script>
<style lang="scss" scoped>
.allChecked__info {
  &__container {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100%;

    padding: 1rem .5rem;
    margin-bottom: 1rem;

    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    color: #505050;

    a {
      color: #04a791 !important;
    }

  }

}

.badges__container {
  display: flex;
  gap: .2rem;
  justify-content: center;
  flex-wrap: wrap;
}

.cards__container {
  display: flex;
  justify-content: space-between;
  gap: 1.5rem;
  margin-top: 2rem;
  margin-bottom: 1.5rem;

  @media screen and (max-width: 768px) {
    overflow: scroll;
  }

  .head-card {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    padding: 0.75rem 1rem;
    height: 5rem;
    width: 25%;

    background: #ffffff;
    box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.12);
    border-radius: 4px;

    @media screen and (max-width: 768px) {
      min-width: 12rem;
    }

    &__left {
      &__title {
        font-size: 0.75rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #8898aa;
        margin-bottom: 0.5rem;
      }

      &__info {
        font-weight: 600;
        font-size: 1rem;
        line-height: 100%;
        text-transform: uppercase;
        color: #4f5358;
      }

      .money::before {
        content: "R$ ";
      }

      .percent::after {
        content: " %";
      }
    }

    &:nth-child(1) .head-card__right {
      background: linear-gradient(90deg, #f53959 0%, #f55d39 100%);
    }

    &:nth-child(2) .head-card__right {
      background: linear-gradient(90deg, #fb6641 0%, #fbab40 100%);
    }

    &:nth-child(3) .head-card__right {
      background: linear-gradient(90deg, #2dce8b 0%, #2dceca 100%);
    }

    &:nth-child(4) .head-card__right {
      background: linear-gradient(180deg, #11c8ef 0%, #1275ef 100%);
    }

    &__right {
      width: 2rem;
      height: 2rem;
      aspect-ratio: 1;
      border-radius: 999px;

      display: flex;
      align-items: center;
      justify-content: center;

      i::before {
        font-size: 1rem;
        background: linear-gradient(180deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0) 137.5%);
        background-clip: text;
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
      }
    }
  }
}

.title-line {
  width: 40px;
  height: 6px;
  margin: 22px 267px 9px 0px;
  border-radius: 3px;
  background-color: #fff;
}

.top-BG {
  position: absolute;
  z-index: -1;
  top: 0;
  left: 0;
  width: 100%;
  height: 55vh;

  background: linear-gradient(90deg, #2dce89 0%, #2dcecc 100%);
}
</style>
<style lang="scss">

.agendamento__passed{
  background-color: #da3131;
  a {
    color: #ffffff !important;
  }
}
.agendamento__today{
  background-color: #75c044;
  a {
    span{
      color: #ffffff !important;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/private/cobranca/cobranca.vue